import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { render } from 'react-dom';

import { IExtractAndReplaceJournalBannersItem } from './extractAndReplaceJournalBanners';
import { PostBannerDecorator } from '../../../components/PostBannerDecorator';

interface IUseContentJournalBannersParams {
  onClick?(url: string, position: IExtractAndReplaceJournalBannersItem['position']): void;
}

/**
 * Рендерит и управляет коллапсерами в посте
 */
export const useContentJournalBanners = (
  extractedJournalBannersItems: IExtractAndReplaceJournalBannersItem[],
  onClick?: IUseContentJournalBannersParams['onClick'],
) => {
  /** Отправляет клик по баннеру */
  const handlePostBannerClick = useCallback(
    (url: string, position: IExtractAndReplaceJournalBannersItem['position']) => {
      if (!url || !onClick) {
        return;
      }

      onClick(url, position);
    },
    [onClick],
  );

  /** Рендерит баннеры */
  useEffect(() => {
    extractedJournalBannersItems.forEach(banner => {
      render(
        <PostBannerDecorator onClick={url => handlePostBannerClick(url, banner.position)}>
          {/* eslint-disable react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: banner.outerHtml }} />
        </PostBannerDecorator>,
        document.getElementById(banner.id),
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
